import type { FaireProductEntity } from "../../entity_types/product";

export const p_2e2hpd7fg4: FaireProductEntity = {
  token: "p_2e2hpd7fg4",
  type: "product",
  name: "Mirror Chain Necklace - Tarnish-free Gold Chain",
  brandToken: "b_9k8cb79ew4",
  brandName: "Blueyejewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/e49e56560b998f5384d4b487b71fcc719fbc19014d95f4ea6abf5fabca32e2eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f144e687402d4745b6a5366c65dbad7b31bad86311986943d53c7d1aaeee17b5.jpeg",
    "https://cdn.faire.com/fastly/62ec8ddd248bddb24916e15093a130431924e67be189454f17787bb65e9e166c.png",
    "https://cdn.faire.com/fastly/2c14be5306c3ec9a0a4400f7a730ad981d293998033a54e7052a90354ae4a958.jpeg",
    "https://cdn.faire.com/fastly/289950be60eece88c9ec5340dc90be9b6188d5fc5e01ec79168ed8fa21939384.jpeg",
    "https://cdn.faire.com/fastly/95f52a936657940ee647a9b0b2657655b5bde88647fd7133f3744d3a630ea22e.jpeg",
    "https://cdn.faire.com/fastly/57c64bda147b4cc6a3b3af1a49bf12d47881010545ef607fe61dbfa419bd7916.jpeg",
    "https://cdn.faire.com/fastly/74f521d6d175c026a2be24981330af59e3333af08a9f4d90feeb86796966bb9a.jpeg",
    "https://cdn.faire.com/fastly/1f55600646c9944f48f38b14b5b06ec776d365caea9a2ba72a40199ecc720244.jpeg",
  ],
  priceDollars: 13.72,
  description:
    '***For US customers: No surprise tariff or brokerage fees. Any fees shown at checkout are fully covered upfront, with no extra charges on delivery. We take care of everything so customs is seamless for you.\n\nDelicate and minimalist in design, this shimmering mirror chain necklace will match any attire from casual smart to formal. Wear it solo or pair it with other minimalistic chains of your choice. Crafted in stainless steel, this necklace is non tarnish and waterproof! \n\nLength \t: 12 to 20 inches + 2" extender\nMaterial\t: Stainless Steel\nFinish:  Silver and 18k Gold PVD Plated \nClosure\t: Lobster Claw Clasp\n\nFREE RETAIL-READY PACKAGING\nEach item is carefully packaged for a polished presentation. Earrings come on off-white square cards featuring our logo (BEJ or Blueye Jewelry) and the material (stainless steel or sterling silver). Necklaces and bracelets are packaged on small cards with our brand name on the front and material on the back, then placed in long white polybags. Rings are packaged WITHOUT cards in zipped bags with size stickers.\n\nIf you prefer to use your own cards, please let us know, and we will package your items without using our branded cards.\n\n*We offer personalization. Please contact us to customize your pieces.',
  tags: [],
  msrpDollars: 27.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:27.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
